import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3h5v5","key":"svg-0"}],["path",{"d":"M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93","key":"svg-1"}]]

const IconArrowBearRight = createReactComponent('outline', 'arrow-bear-right', 'ArrowBearRight', __iconNode);

export default IconArrowBearRight;